/* eslint-disable */
export const baseUrl = "http://47.75.119.124/Service";  // 开发: http://192.168.1.248:8020 线上：  http://47.75.119.124/Service

// url2
export const url_CM = 'http://47.75.119.124'; // 开发：http://47.56.195.204, 线上： ''

// url LN
export const url_LN = 'http://47.56.71.41:9999';  // 线上：47.56.71.41, 开发：192.168.1.59:9999

// url unilateral local
export const url_LN_local = 'http://47.75.119.124:8025'; // http://192.168.1.221:8025 // http://47.75.119.124:8025

// 临时策略 url
export const url_temp = "http://47.75.119.124:8026";  // http://192.168.1.221 // http://47.75.119.124

// 任务请求等待时间
export const taskWaitTimer = 8;

// 单边 url
export  const socket_url_ln = "ws://47.75.119.124:8025"; // ws://47.75.119.124:8025 , // ws://192.168.1.221:8025

export const LOCAL_URL = 'http://192.168.1.221:8025';

// 曹觅矿机
export const URL_KJ = "http://47.75.119.124/ts1";

//本地
export const URL_LN2 = 'http://47.75.119.124:8026'